// Keep up to date with pplx/backend/core/version_utils.py
export const WEB_VERSION = '2.18';
export const WEB_SOURCE = 'default';
export const SERVER_SOURCE = 'server';
export const MWEB_SOURCE = 'mweb';
export const WINDOWSAPP_SOURCE = 'windowsapp';
export const COMPUTERAPP_SOURCE = 'personal-computer-macos';
export const WINDOWS_COMPUTERAPP_SOURCE = 'personal-computer-windows';
export const LINUX_COMPUTERAPP_SOURCE = 'personal-computer-linux';
export const XPLAT_MACOS_COMPUTERAPP_SOURCE = 'personal-computer-xplat-macos';
export const REASON_HEADER = 'X-Perplexity-Request-Reason';
export const REQUEST_ID_HEADER = 'X-Request-ID';
export const APP_DOMAIN_HEADER = 'X-App-Domain';
// Set by a transport on a synthetic error response to end an SSE subscription
// for good; even polling streams stop reconnecting when they see it.
export const SSE_TERMINAL_HEADER = 'X-Perplexity-SSE-Terminal';
//# sourceMappingURL=constants.js.map